export default __webpack_public_path__ + "static/media/15.8e4d5948.png";